/* tslint:disable */
/* eslint-disable */
/**
 * Ster.nl API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  SterWebsiteModelPriceCompareCalculateResultForOperator,
  SterWebsiteModelPriceCompareCalculateResultForOperatorFromJSON,
  SterWebsiteModelPriceCompareCalculateResultForOperatorFromJSONTyped,
  SterWebsiteModelPriceCompareCalculateResultForOperatorToJSON,
} from "./";

/**
 *
 * @export
 * @interface SterWebsiteModelPriceCompareCalculateResultItem
 */
export interface SterWebsiteModelPriceCompareCalculateResultItem {
  /**
   *
   * @type {string}
   * @memberof SterWebsiteModelPriceCompareCalculateResultItem
   */
  targetGroupName: string;
  /**
   *
   * @type {Array<SterWebsiteModelPriceCompareCalculateResultForOperator>}
   * @memberof SterWebsiteModelPriceCompareCalculateResultItem
   */
  results: Array<SterWebsiteModelPriceCompareCalculateResultForOperator>;
}

export function SterWebsiteModelPriceCompareCalculateResultItemFromJSON(
  json: any
): SterWebsiteModelPriceCompareCalculateResultItem {
  return SterWebsiteModelPriceCompareCalculateResultItemFromJSONTyped(
    json,
    false
  );
}

export function SterWebsiteModelPriceCompareCalculateResultItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SterWebsiteModelPriceCompareCalculateResultItem {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    targetGroupName: json["targetGroupName"],
    results: (json["results"] as Array<any>).map(
      SterWebsiteModelPriceCompareCalculateResultForOperatorFromJSON
    ),
  };
}

export function SterWebsiteModelPriceCompareCalculateResultItemToJSON(
  value?: SterWebsiteModelPriceCompareCalculateResultItem | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    targetGroupName: value.targetGroupName,
    results: (value.results as Array<any>).map(
      SterWebsiteModelPriceCompareCalculateResultForOperatorToJSON
    ),
  };
}
